// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-detail-sidebar-delivery-day-window-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: auto;
    margin: 10px 0;
  }
  .department-detail-sidebar-delivery-day-window-day-name {
    font-size: 14px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    margin-left: 10px;
  }
  .department-detail-sidebar-delivery-day-window-available {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
  }
  .department-detail-sidebar-delivery-day-window-open {
    margin: 0 5px;
  }
  .department-detail-sidebar-delivery-day-window-close {
    margin: 0 5px;
  }
  .department-detail-sidebar-delivery-day-window-switch {
  }
  .department-detail-sidebar-delivery-day-window-time-section {
    display: flex;
    flex-direction: row;
  }
  .department-detail-sidebar-delivery-day-window-day-header {
    font-size: 12px;
    font-weight: 500;
    margin-top: auto;
    margin-bottom: auto;
  }
  .department-detail-sidebar-delivery-day-window-editble-field-header {
    font-size: 12px;
    font-weight: 500;
    color: #737980;
    margin-top: auto;
    margin-bottom: auto;
    text-align: center;
    width: 100%;
  }
  .department-detail-sidebar-delivery-day-window-item {
    height: 100%;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
  }
  .department-detail-sidebar-delivery-day-window-item:nth-child(2) {
      margin-left: 0;
    }
  .department-detail-sidebar-delivery-day-window-editable-item {
    height: 100%;
    width: 45%;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .department-detail-sidebar-delivery-day-window-editable-item:nth-child(2) {
      margin-left: 0;
    }
  .department-detail-sidebar-delivery-day-window-uneditable-item {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .department-detail-sidebar-delivery-day-window-time-picker {
    width: 100%;
  }
`, "",{"version":3,"sources":["webpack://./app/components/DepartmentDetailSidebar/components/DepartmentDetailSidebarDeliveryPreferences/components/ReceivingHours/DayWindow/style.css"],"names":[],"mappings":"AACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,cAAc;EAChB;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;EAEA;IACE,aAAa;EACf;EAEA;IACE,aAAa;EACf;EAEA;EACA;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EAKrB;EAHE;MACE,cAAc;IAChB;EAGF;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EAKrB;EAHE;MACE,cAAc;IAChB;EAGF;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;EAEA;IACE,WAAW;EACb","sourcesContent":[".department-detail-sidebar-delivery-day-window {\n  &-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: auto;\n    margin: 10px 0;\n  }\n\n  &-day-name {\n    font-size: 14px;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    text-align: left;\n    margin-left: 10px;\n  }\n\n  &-available {\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  &-open {\n    margin: 0 5px;\n  }\n\n  &-close {\n    margin: 0 5px;\n  }\n\n  &-switch {\n  }\n\n  &-time-section {\n    display: flex;\n    flex-direction: row;\n  }\n\n  &-day-header {\n    font-size: 12px;\n    font-weight: 500;\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n\n  &-editble-field-header {\n    font-size: 12px;\n    font-weight: 500;\n    color: #737980;\n    margin-top: auto;\n    margin-bottom: auto;\n    text-align: center;\n    width: 100%;\n  }\n\n  &-item {\n    height: 100%;\n    width: 100%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    align-items: center;\n\n    &:nth-child(2) {\n      margin-left: 0;\n    }\n  }\n\n  &-editable-item {\n    height: 100%;\n    width: 45%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n\n    &:nth-child(2) {\n      margin-left: 0;\n    }\n  }\n\n  &-uneditable-item {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &-time-picker {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
